import { render, staticRenderFns } from "./OrderLineExtension.vue?vue&type=template&id=40e9c89e&scoped=true&"
import script from "./OrderLineExtension.vue?vue&type=script&lang=ts&"
export * from "./OrderLineExtension.vue?vue&type=script&lang=ts&"
import style0 from "./OrderLineExtension.vue?vue&type=style&index=0&id=40e9c89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9c89e",
  null
  
)

export default component.exports